export const gitCommit = '604426d0'
